<template>
    <div class="generative-ai-usage-trend-content">
        <div class="generative-ai-usage-trend-widget" :class="{'loading-state': isLoading}">
            <div v-if="isLoading">
              <span>
                <i class="fas fa-spinner fa-spin"></i>
              </span>
            </div>
            <div v-else class="chart-area">
              <div class="header-generative-ai-usage-widget">
                <p>Usage Trend</p>
                <button
                  v-if="hasData"
                  @click="handleExportGenAIUsageFile"
                  class="export-button"
                >
                  <p>Export</p>
                </button>
              </div>
              <NoResultsFound v-if="!hasData" class="no-result-content"/>
              <div v-else class="chart-content">
                  <GChart
                  class="g-chart"
                  type="LineChart"
                  :data="generativeAIUsageTrendHistoryData"
                  :options="lineChartOptions"
                  ></GChart>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
import { GChart } from 'vue-google-charts';
import { DateTime } from 'luxon';
import NoResultsFound from '../NoResultsFound.vue';

export default {
  name: 'GenAIUsageTrendWidget',
  components: {
    NoResultsFound,
    GChart
  },
  props: {
    usageHistory: {
      type: Array,
      default: () => [],
    },
    criteria: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      lineChartOptions: {
        height: 300,
        legend: { position: 'bottom' },
        chartArea: {
          width: '90%',
          height: '65%',
        },
        focusTarget: 'category',
        hAxis: { showTextEvery: 4 },
        vAxis: {
          title: 'Transactions',
          titleTextStyle: {
            color: '#4B5178',
            fontSize: 12,
            italic: false
          },
        },
        colors: ['#59CBE8', '#3371FF', '#C964CF'],
      },
      isLoading: false,
      generativeAIUsageHistory: null,
    };
  },
  methods: {
    hAxisController(totalDataCount) {
      // Control displayed h-axis
      if (totalDataCount <= 10) {
        this.lineChartOptions.hAxis.showTextEvery = 1;
      } else if (totalDataCount > 10 && totalDataCount <= 20) {
        this.lineChartOptions.hAxis.showTextEvery = 2;
      } else {
        this.lineChartOptions.hAxis.showTextEvery = 4;
      }
    },
    handleExportGenAIUsageFile() {
      this.$emit('on-export');
    },
  },
  computed: {
    generativeAIUsageTrendHistoryData() {
      let header = ['Date', 'Request', 'Input Token', 'Output Token'];
      const { criteria } = this;
      let dateFormat = 'dd MMM';
      if (criteria) {
        if (criteria.time.granularity === 'month') {
          header = ['Month', 'Request', 'Input Token', 'Output Token'];
          dateFormat = 'M/yy';
        } else if (criteria.time.granularity === 'day') {
          header = ['Date', 'Request', 'Input Token', 'Output Token'];
          dateFormat = 'dd MMM';
        } else if (criteria.time.granularity === 'hour') {
          header = ['Hour', 'Request', 'Input Token', 'Output Token'];
          dateFormat = 'HH:mm';
        }
      }
      if (this.generativeAIUsageHistory && this.generativeAIUsageHistory.length > 0) {
        const dataList = this.generativeAIUsageHistory.map((item) => [
          DateTime.fromMillis(item.date).toFormat(dateFormat),
          item.request,
          item.inputToken,
          item.outputToken
        ]);
        this.hAxisController(dataList.length);
        return [header, ...dataList];
      }
      return [header, ['No data', 0, 0]];
    },
    hasData() {
      if (this.generativeAIUsageHistory
        && this.generativeAIUsageHistory.length > 0
        && this.generativeAIUsageHistory.some((genAiUsage) => genAiUsage.request > 0
          || genAiUsage.inputToken > 0
          || genAiUsage.outputToken > 0)
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    usageHistory(newVal) {
      this.generativeAIUsageHistory = newVal;
    }
  },
};
</script>
<style lang="scss" scoped>
.generative-ai-usage-trend-content{
    padding-top: 24px;
    .export-button {
      border-radius: 24px;
      border: 1px solid #DADCE4;
      padding: 4px 12px;
      margin-left: 8px;
      color: #4848FF;
      background-color: #fff;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      outline: none;
    }
    .generative-ai-usage-trend-widget{
    background-color: #FFFFFF;
    border-radius: 16px;
    height: 100%;
    .header-generative-ai-usage-widget{
      padding: 16px 16px 12px 16px;
      border-bottom: 1px solid #E9EBEC;
      font-size: 16px;
      font-weight: 500;
      line-height: 19.2px;
      color: #111B49;
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
          margin-bottom: 0px
      }
    .line-chart-icon {
      height: 16px;
      width: 16px;
      margin-right: 8px;
    }
    .line-chart-icon.selected{
      height: 32px;
      width: 32px;
      margin-right: 8px;
    }

    .selector-chart-type{
      display: flex;
      align-items: center;
      .item-selector-chart-type{
        color: #868BA6;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .item-selector-chart-type.selected{
        background-color: rgba(51, 113, 255, 0.1);
        color: #3371FF;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        // width: 32px;
        // height: 32px;
      }
    }
    }

    .text-subtitle{
      font-size: 10px;
      font-weight: 400;
      line-height: 15px;
      color: #878A99;
    }
    .chart-area{
      display: flex;
      flex-direction: column;
      height: 100%;
      .no-result-content{
        margin-top: 97px;
        margin-bottom: 97px;
      }
      .chart-content{
        padding: 0px 0px 20px 0px;
      }
    }
    &.loading-state{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 400px;
    }
  }

}
</style>
